import { render, staticRenderFns } from "./moban.vue?vue&type=template&id=b6ec7bfe&scoped=true&"
import script from "./moban.vue?vue&type=script&lang=js&"
export * from "./moban.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6ec7bfe",
  null
  
)

export default component.exports